// import React, { useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { openPopover, toggleBottomBar } from "../../store/common/uiSlice";
// import ToggleSwitch from "../common/ToggleSwitch";
// import SlidesList from "./slides/SlidesList";
// import MenuButton from "../common/MenuButton";
// import { TOOLS_POPOVERS } from "../../constants";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
// import Joyride, { STATUS } from "react-joyride";

// const avatarRequiresTools = ["useai", "script"];

// function BottomBar() {
//   const [steps] = useState([
//     {
//       content: <h2>Let's begin our journey!</h2>,
//       locale: { skip: <strong>SKIP</strong> },
//       placement: "center",
//       target: "body",
//     },
//     {
//       content: <h2>Access All the Templates</h2>,
//       placement: "bottom",
//       target: "#step-1",
//       // title: "First step"
//     },
//     {
//       content: <h2>Choose from a wide variety of avatars to select from.</h2>,
//       placement: "bottom",
//       target: "#step-2",
//       // title: "Second step"
//     },
//     {
//       content: <h2>Use audio or text scripts to generate scripts.</h2>,
//       placement: "bottom",
//       target: "#step-3",
//       // title: "Third step"
//     },
//     {
//       content: <h2>Use ChatGPT to generate scripts.</h2>,
//       placement: "bottom",
//       target: "#step-4",
//       // title: "Fourth step"
//     },
//     {
//       content: (
//         <h2>
//           Explore a diverse selection of images to find the perfect one for you.
//         </h2>
//       ),
//       placement: "bottom",
//       target: "#step-5",
//       // title: "Fifth step"
//     },
//     {
//       content: <h2>You can also set the images as backgrounds.</h2>,
//       placement: "bottom",
//       target: "#step-6",
//       // title: "Six step"
//     },
//     {
//       content: <h2>Add music to your templates.</h2>,
//       placement: "bottom",
//       target: "#step-7",
//       // title: "Seventh step"
//     },
//     {
//       content: <h2>Add videos to the canvas.</h2>,
//       placement: "bottom",
//       target: "#step-8",
//       // title: "Eighth step"
//     },
//     {
//       content: <h2>Select the perfect text for your slides.</h2>,
//       placement: "bottom",
//       target: "#step-9",
//       // title: "Ninth step"
//     },
//     {
//       content: <h2>Choose from a wide range of assets.</h2>,
//       placement: "bottom",
//       target: "#step-10",
//       // title: "Tenth step"
//     },
//   ]);

//   const [run, setRun] = useState(true);
//   const { type } = useSelector((state) => state.project);
//   const isFeatureTemplate = useMemo(() => type === "template", [type]);
//   const dispatch = useDispatch();
//   const { popover, bottomBarExpanded } = useSelector((state) => state.ui);
//   const { currentSlideIndex, slides } = useSelector((state) => state.slides);
//   const currentSlide = useMemo(
//     () => slides[currentSlideIndex],
//     [currentSlideIndex, slides]
//   );
//   const avatar = useMemo(() => {
//     return currentSlide?.objects.find((obj) => obj.type === "avatar") || null;
//   }, [currentSlide]);
//   const scriptValidationMessage = useMemo(
//     () => (!avatar ? "Please add avatar to use this tool" : ""),
//     [avatar]
//   );

//   const handleToggle = () => {
//     dispatch(toggleBottomBar());
//   };
//   const trial = useSelector((state) => state?.user?.details?.data?.trial);
//   const popovers = TOOLS_POPOVERS(trial, currentSlideIndex, isFeatureTemplate);

//   return (
//     <div
//       className={`absolute bottom-0 p-0 w-full ${
//         bottomBarExpanded ? "h-64" : "h-16"
//       }`}
//     >
//       <div
//         className={`bg-white p-2 px-4 shadow-lg border border-gray-300 flex items-center transition-height duration-300 ease-in-out h-16`}
//       >
//         {/* <ToggleSwitch
//           // textDisabled={"Timeline"}
//           textEnabled={"Slides"}
//         /> */}

//         <div className="flex-1 flex justify-center space-x-1">
//           {(popovers || []).map((pop, index) => (
//             <MenuButton
//               key={index}
//               id={`step-${index + 1}`}
//               icon={pop?.icon}
//               iconOn={pop?.iconHover}
//               text={pop?.name}
//               active={pop?.name === popover}
//               onClick={() => dispatch(openPopover(pop?.name))}
//               disabled={
//                 pop?.disabled ||
//                 (avatarRequiresTools.includes(pop?.name.toLowerCase()) &&
//                   scriptValidationMessage)
//               }
//               message={
//                 avatarRequiresTools.includes(pop?.name.toLowerCase()) &&
//                 scriptValidationMessage
//               }
//             />
//           ))}
//           <Joyride
//             // continuous
//             // callback={() => {}}
//             styles={{
//               options: {
//                 arrowColor: "#e3ffeb",
//                 // backgroundColor: '#e3ffeb',
//                 overlayColor: "rgba(81, 82, 81)",
//                 primaryColor: "#000",

//                 textColor: "#050505",
//                 // width: 900,
//                 zIndex: 1000,
//               },
//             }}
//             run={run && steps.length > 0}
//             continuous={true}
//             steps={steps}
//             hideCloseButton
//             scrollToFirstStep
//             // showProgress={true}
//             showSkipButton={true}
//             callback={(data) => {
//               const { status } = data;
//               if (status === "finished" || status === "skipped") {
//                 setRun(false);
//               }
//             }}
//           />
//         </div>

//         <UpArrowButton onToggle={handleToggle} expanded={!bottomBarExpanded} />
//       </div>
//       {bottomBarExpanded && (
//         <div className={`h-48 bg-gray-300 flex items-center`}>
//           <SlidesList />
//         </div>
//       )}
//     </div>
//   );
// }

// function UpArrowButton({ onToggle, expanded }) {
//   return (
//     <button onClick={onToggle} className="p-2 hover:bg-gray-100 rounded">
//       Add Slides
//       <FontAwesomeIcon
//         className="ml-1"
//         icon={expanded ? faArrowDown : faArrowUp}
//       />
//     </button>
//   );
// }

// export default BottomBar;

import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openPopover, toggleBottomBar } from "../../store/common/uiSlice";
import ToggleSwitch from "../common/ToggleSwitch";
import SlidesList from "./slides/SlidesList";
import MenuButton from "../common/MenuButton";
import { TOOLS_POPOVERS } from "../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Joyride from "react-joyride";

const avatarRequiresTools = ["useai", "script"];

function BottomBar() {
  const [steps] = useState([
    {
      content: <h2>Let's begin our journey!</h2>,
      locale: { skip: <strong>SKIP</strong> },
      placement: "center",
      target: "body",
    },
    {
      content: <h2>Access All the Templates</h2>,
      placement: "bottom",
      target: "#step-1",
      // title: "First step"
    },
    {
      content: <h2>Choose from a wide variety of avatars to select from.</h2>,
      placement: "bottom",
      target: "#step-2",
      // title: "Second step"
    },
    {
      content: <h2>Use audio or text scripts to generate scripts.</h2>,
      placement: "bottom",
      target: "#step-3",
      // title: "Third step"
    },
    {
      content: <h2>Use ChatGPT to generate scripts.</h2>,
      placement: "bottom",
      target: "#step-4",
      // title: "Fourth step"
    },
    {
      content: (
        <h2>
          Explore a diverse selection of images to find the perfect one for you.
        </h2>
      ),
      placement: "bottom",
      target: "#step-5",
      // title: "Fifth step"
    },
    {
      content: <h2>You can also set the images as backgrounds.</h2>,
      placement: "bottom",
      target: "#step-6",
      // title: "Six step"
    },
    {
      content: <h2>Add music to your templates.</h2>,
      placement: "bottom",
      target: "#step-7",
      // title: "Seventh step"
    },
    {
      content: <h2>Add videos to the canvas.</h2>,
      placement: "bottom",
      target: "#step-8",
      // title: "Eighth step"
    },
    {
      content: <h2>Select the perfect text for your slides.</h2>,
      placement: "bottom",
      target: "#step-9",
      // title: "Ninth step"
    },
    {
      content: <h2>Choose from a wide range of assets.</h2>,
      placement: "bottom",
      target: "#step-10",
      // title: "Tenth step"
    },
  ]);

  const [tutorialCompleted, setTutorialCompleted] = useState(false);
  const [run, setRun] = useState(true);
  const dispatch = useDispatch();
  const {
    type,
    isFaceless,
    isOnlyAvatar,
    isDoc,
    isLinkVideo,
    isNonVoice,
    isOnlyAIVoice,
  } = useSelector((state) => state.project);
  console.log("constant File", isNonVoice);
  console.log("isOnlyAIVoices", isOnlyAIVoice);
  const isFeatureTemplate = useMemo(() => type === "template", [type]);
  const { popover, bottomBarExpanded } = useSelector((state) => state.ui);
  const { currentSlideIndex, slides } = useSelector((state) => state.slides);
  const currentSlide = useMemo(
    () => slides[currentSlideIndex],
    [currentSlideIndex, slides]
  );
  const avatar = useMemo(() => {
    return currentSlide?.objects.find((obj) => obj.type === "avatar") || null;
  }, [currentSlide]);
  const scriptValidationMessage = useMemo(
    () => (!avatar ? "Please add avatar to use this tool" : ""),
    [avatar]
  );

  useEffect(() => {
    const tutorialCompletedSession =
      sessionStorage.getItem("tutorialCompleted");
    if (tutorialCompletedSession === "true") {
      setRun(false);
      setTutorialCompleted(true);
    }
  }, []);

  const handleToggle = () => {
    dispatch(toggleBottomBar());
  };
  const isonlyavtar = window.location.pathname.includes("only-avatar");

  const trial = useSelector((state) => state?.user?.details?.data?.trial);
  console.log("isNonVoice123", isNonVoice);

  const popovers = TOOLS_POPOVERS(
    trial,
    currentSlideIndex,
    isFeatureTemplate,
    undefined,
    isFaceless,
    isOnlyAvatar,
    isDoc || isLinkVideo,
    isNonVoice,
    isOnlyAIVoice
  );

  return (
    <div
      className={`absolute bottom-0 p-0 w-full  ${
        bottomBarExpanded ? "h-64" : "h-16"
      }`}
      style={{ zIndex: 2 }}
    >
      <div
        className={`bg-white p-2 px-4 shadow-lg border border-gray-300 flex items-center transition-height duration-300 ease-in-out h-16`}
      >
        <div className="flex-1 flex justify-center space-x-1">
          {(popovers || [])
            .filter((t) => !t.isHidden)
            .map((pop, index) => (
              <MenuButton
                key={`${pop.name} ${index}`}
                id={`step-${index + 1}`}
                icon={pop?.icon}
                iconOn={pop?.iconHover}
                text={pop?.name}
                active={pop?.name === popover}
                onClick={() => dispatch(openPopover(pop?.name))}
                disabled={
                  pop?.disabled ||
                  (!isFaceless &&
                    avatarRequiresTools.includes(pop?.name.toLowerCase()) &&
                    scriptValidationMessage)
                }
                message={
                  !isFaceless &&
                  avatarRequiresTools.includes(pop?.name.toLowerCase()) &&
                  scriptValidationMessage
                }
              />
            ))}
          {!tutorialCompleted && (
            <Joyride
              styles={{
                options: {
                  arrowColor: "#e3ffeb",
                  // backgroundColor: '#e3ffeb',
                  overlayColor: "rgba(81, 82, 81)",
                  primaryColor: "#000",

                  textColor: "#050505",
                  // width: 900,
                  zIndex: 1000,
                },
              }}
              run={run && steps.length > 0}
              continuous={true}
              steps={steps}
              hideCloseButton
              scrollToFirstStep
              showSkipButton={true}
              callback={(data) => {
                const { status } = data;
                if (status === "finished" || status === "skipped") {
                  setRun(false);
                  setTutorialCompleted(true);
                  sessionStorage.setItem("tutorialCompleted", "true");
                }
              }}
            />
          )}
        </div>

        {!isonlyavtar && !isOnlyAIVoice && (
          <UpArrowButton onToggle={handleToggle} expanded={bottomBarExpanded} />
        )}
      </div>
      {bottomBarExpanded && (
        <div className={`h-48 bg-gray-300 flex items-center`}>
          <SlidesList />
        </div>
      )}
    </div>
  );
}

function UpArrowButton({ onToggle, expanded }) {
  return (
    <button onClick={onToggle} className="p-2 hover:bg-gray-100 rounded">
      Slides
      <FontAwesomeIcon
        className="ml-1"
        icon={expanded ? faArrowDown : faArrowUp}
      />
    </button>
  );
}

export default BottomBar;
